import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { take } from "rxjs/operators";
import { event_occurrences } from "src/app/components/calendar/calendar.model";
import { ApiService } from "src/app/services/api/api.service";
import moment from 'moment';
import 'moment-timezone';
@Injectable({
    providedIn: 'root',
})
export class FieldSchedulesBLL {

    private isLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    readonly isLoading$: Observable<boolean> = this.isLoading.asObservable();

    private isLoadingToday: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    readonly isLoadingToday$: Observable<boolean> = this.isLoadingToday.asObservable();

    private sessions: BehaviorSubject<any> = new BehaviorSubject<any>([]);
    readonly sessions$: Observable<any> = this.sessions.asObservable();

    private invited_sessions: BehaviorSubject<any> = new BehaviorSubject<any>([]);
    readonly invited_sessions$: Observable<any> = this.invited_sessions.asObservable();


    private all_sessions_on_date: BehaviorSubject<any> = new BehaviorSubject<any>([]);
    readonly all_sessions_on_date$: Observable<any> = this.all_sessions_on_date.asObservable();

    selectedSchedule$: Subject<any> = new Subject<any>();

    constructor(
        private api: ApiService
    ) { }

    reset_sessions() {
        this.selectedSchedule$.next(null);
    }

    get_all_sessions(date, admin: any = null, is_practice: boolean = true) {
        this.isLoading.next(true);
        let url = `field-events?type=get_all_field_events&date_of_game_events=${date}&timezone=${moment.tz.guess()}&is_practice=${is_practice}`;

        if (admin?.ad_admin_id) {
            url += `&admin_id=${admin.ad_admin_id}`;
        }

        if (admin?.ad_admin_email) {
            url += `&admin_email=${admin.ad_admin_email}`;
        }

        this.api.get(url).pipe(take(1)).subscribe((res: any) => {
            this.all_sessions_on_date.next(res?.field_events);
            this.isLoading.next(false);
        }, (err) => {
            this.isLoading.next(false);
        });
    }

    get_todays_sessions(admin: any = null) {
        //Enum: expected today, default or date: Date
        this.isLoadingToday.next(true);
        // console.log()
        let url = `field-events?type=get_all_field_events&numbers_of_game_events=3-days&timezone=${moment.tz.guess()}`;

        if (admin?.ad_admin_id) {
            url += `&admin_id=${admin.ad_admin_id}`;
        }

        if (admin?.ad_admin_email) {
            url += `&admin_email=${admin.ad_admin_email}`;
        }

        this.api.get(url).pipe(take(1)).subscribe((res: any) => {
            this.sessions.next(res?.field_events);
            this.invited_sessions.next(res?.invited_field_events);
            this.isLoadingToday.next(false);
        }, (err) => {
            this.isLoadingToday.next(false);
        });
    }

    delete_activity(id: string, date: string, admin: any = null) {
        this.isLoading.next(true);
        let url = `field-events?type=delete_event&id=${id}`;
        if (admin?.ad_admin_id) {
            url += `&admin_id=${admin.ad_admin_id}`;
        }

        if (admin?.ad_admin_email) {
            url += `&admin_email=${admin.ad_admin_email}`;
        }
        
        this.api.delete(url).pipe(take(1)).subscribe((res: any) => {
            this.get_all_sessions(moment(date).format('YYYY-MM-DD'), admin);
            this.get_todays_sessions(admin);
            this.isLoading.next(false);
        }, (err) => {
            this.isLoading.next(false);
        });
    }

}